export class Imagem {
    id: string;
    imgNome: string;
    imgTamanho: string;
    imgConteudo: string;
    base64Zip: any;
}
